module.exports = __webpack_public_path__ + "static/media/wave-grc-mobile.83f8f920.svg";